module.exports = __webpack_public_path__ + "img/nyforlova.f2fd3003.png";